var BaseViews = require('../base');
require('./tag-bar/tag-bar.scss');
var View = BaseViews.LayoutView.extend({
  template: require('./tag-bar/tag-bar.html'),
  className: 'fmcy-tag-bar fmcy-tag-bar-pinned-right',
  initialize: function (options) {
    var self = this;
    this.options = _.defaults(
        options || {},
        {
          showOnSaleTag: false,
          showOnClearanceTag: false,
          showOrganicTag: false,
          showVeganTag: false,
          showCBDTag: false,
          showCBNCBGTag: false,
          showBcGrownTag: false,
          showFarmExclusiveTag: false,
          productTagText: ''
        }
    );
  },
  serializeData: function () {
    if (this.options.productTagText) {
      this.$el.addClass('fmcy-showing-product-tag');
    }
    return {
        options: this.options
    };
  }
});
module.exports = View;



/** WEBPACK FOOTER **
 ** ./assets/js/common/product-tile/tag-bar.js
 **/